
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data() {
    return {
      carrousels: [
        "carrousel-1.png",
        "carrousel-2.png",
        "carrousel-3.png",
        "carrousel-4.png",
        "carrousel-5.png",
      ],
    };
  },

  head() {
    return {
      title: "Comment créer un Carrousel Instagram ? Augmenter son audience",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez les secrets des carrousels Instagram pour captiver votre audience ! De la création efficace à l'augmentation de l'engagement et de vos abonnées.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Comment créer un Carrousel Instagram ? Augmenter son audience",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez les secrets des carrousels Instagram pour captiver votre audience ! De la création efficace à l'augmentation de l'engagement et de vos abonnées.",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-apropos.jpg"),
        // },
      ],
    };
  },
};
